import { Injectable, inject } from '@angular/core';
import { ANALYTICS_ADAPTER } from './analytics.adapter';
import { AnalyticsProperties } from './analytics.types';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private readonly adapter = inject(ANALYTICS_ADAPTER);

  public track(event: string, properties?: AnalyticsProperties): void {
    this.invoke(() => this.adapter.track(event, properties));
  }

  public identify(userId: string): void {
    this.invoke(() => this.adapter.identify(userId));
  }

  public setContext(properties: AnalyticsProperties): void {
    this.invoke(() => this.adapter.setContext(properties));
  }

  public reset(): void {
    this.invoke(() => this.adapter.reset());
  }

  private invoke(operation: () => void): void {
    try {
      operation();
    } catch {
      // Analytics failures must never affect the host application.
    }
  }
}
